import { useEffect } from 'react';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem('krysha_token');
export const setToken = (t) => localStorage.setItem('krysha_token', t);
export const clearToken = () => localStorage.removeItem('krysha_token');
export const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const mediaUrl = (path, withAuth = false) => {
  if (!path) return null;
  const base = `${process.env.REACT_APP_BACKEND_URL}${path}`;
  return withAuth ? `${base}?auth=${encodeURIComponent(getToken() || '')}` : base;
};

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '—');
export const fmtTime = (d) => (d ? new Date(d).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }) : '');

export const fmtErr = (detail, fallback = 'Something went wrong. Please try again.') => {
  if (detail == null) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ');
  return String(detail);
};

export const useNoIndex = () => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => { document.head.removeChild(meta); };
  }, []);
};
